module.exports = {
  nav: {
    home: '首页',
    about: '关于京贝尔',
    ecology: '京贝尔生态',
    team: '人才力量',
    ahead: '展望京贝尔',
    contact: '联系京贝尔',
    gtb: '通证GTB'
  },
  foot: {
    tel: '咨询电话',
    email: '合作邮箱',
    address: '公司地址',
    addressval: '山东省青岛市市南区燕儿岛路10号凯悦中心写字楼6楼',
    qr1: '订阅号',
    qr2: '服务号',
  },
  home: {
    img1: '/images/home/zh11.jpg',
    img2: '/images/home/zh21.jpg',
    cards1: [{
        id: 1,
        img: '/images/home/12.jpg'
      },
      {
        id: 2,
        img: '/images/home/zh12.png'
      },
      {
        id: 3,
        img: '/images/home/zh13.png'
      },
      {
        id: 4,
        img: '/images/home/15.jpg'
      },
    ],
    cards2: [{
        id: 1,
        icon: '/images/home/21.png',
        title: '品牌服务商',
        ct: '京贝尔不做品牌 京贝尔成就品牌 京贝尔助推上线'
      },
      {
        id: 2,
        icon: '/images/home/22.png',
        title: '循环服务商',
        ct: '京贝尔倡导循环服务，致力于为全世界75亿世界公民 以《关贸总协定》的逻辑建立（全球消费总协定）， 更多的消费者将会通过京贝尔自组织赢消订单系统， 自发或者自觉地参与到京贝尔智能合约机制中来'
      }
    ],
    cards3: [{
        id: 1,
        title: "联营商",
        bg: '/images/home/01.jpg',
        ct: '/images/home/zh01.png',
      },
      {
        id: 2,
        title: "网络移民",
        bg: '/images/home/02.jpg',
        ct: '/images/home/zh02.png',
      },
      {
        id: 3,
        title: "三创协同、六网互动",
        bg: '/images/home/03.jpg',
        ct: '/images/home/zh03.png',
      },
      {
        id: 4,
        title: "一网一店",
        bg: '/images/home/04.jpg',
        ct: '/images/home/zh04.png',
      },
      {
        id: 5,
        title: "三通",
        bg: '/images/home/05.jpg',
        ct: '/images/home/zh05.png',
      },
      {
        id: 6,
        title: "五全",
        bg: '/images/home/06.jpg',
        ct: '/images/home/zh06.png',
      },
    ],
  },
  ec: {
    img1: '/images/ecology/zh01.jpg',
    img2: '/images/ecology/zh31.jpg',
    img3: '/images/ecology/zh32.jpg',
    img4: '/images/ecology/zh33.jpg',
    p1: '数字化经济大形势下，通证经济风起云涌。通用渠道，通用利润，通用积分，是贸易流通业态的大变革！资源互通，万物联动，是未来的价值趋势。',
    tt11: '京贝尔通证商业',
    ct11: '通证电商是互联网商业与区块链技术的有效融合。互联网商业本身具有普遍性，方便性、协调性的特点，而区块链技术具有公平、解决信任问题及不可篡改性等优势，区块链的出现，将会对互联网时代的商业模式进行革新，这一技术的出现，能完美弥补互联网商业传输效率不足，加深市场厚度',
    tt12: '通证商业与互联网商业、新零售有什么不同',
    ct12: '互联网商业：以互联网为基础进行个体与企业、销售之间间接的商业交易.新零售：以信息技术为驱动，以消费者体验为核心，将线下线上的的人、货、场三要素重构，形成全新商业形态.通证商业通证商业是在新零售的基础上实现了大小企业的平等，真正实现了大小企业的平等，真正实现了把数据的价值还给用户。将带给我们一个新一代信息技术＋自由公平理念＋新商业规则＋法律规范新世界.',
    timeline: [{
        id: 1,
        date: "1999年",
        title: "中国电商元年",
        text: "中国电商在这一年真正进入了实 质化商业阶段。5月8848网成立， 8月易趣网成立，9月阿里巴巴成 立，11月当当网成立，9月6日中 国国际电子商务应用博览会。另 外携程、盛大等都在这年成立",
      },
      {
        id: 2,
        date: "2011年",
        title: "资本逐鹿电商行业",
        text: "十年间，越来愈多的风投转向电 商，加速了电商企业的上市，而 淘宝和支付宝的成立更为阿里巴 巴的庞大帝国奠定了基础，马云 于2004年首次提出“网商”概念， 随后京东、美团、滴滴等等越来 越多的互联网商业企业诞生，加 速了整个互联网商业的发展",
      },
      {
        id: 3,
        date: "2016年",
        title: "新零售概念风靡全球",
        text: "2016年马云提出“新零售”概念，目 前国内国际市场形成了形态各异的新 零售商业模型，截止目前，盈利模式 依旧不稳定，从而需要有更稳固的机 制来助推新零售模型升级",
      },
      {
        id: 4,
        date: "2019年",
        title: "京贝尔通证行业应运而生",
        text: "经过三年时间的技术研发， 京贝尔在新零售的基础上融 合区块链技术，实现通证商 城，云店，数据坞，社交APP 全链条循环生态",
      },
    ],
    tt21: '市场需求',
    ct21: '商品流通消费 是经济发展的前提， 是一切金融的基础，培育一批发展平台经济成效较好的千亿级商 品市场，是 现代化经济要求的商品流通体系',
    tt22: '商务部指导意见',
    ct22: '响应商务部等12部门 关于推进商品交易 市场发展平台 经济的指导意见',
    tt23: '发展趋势',
    ct23: '助推300家生产型企业上市，，实现消 费者、渠道商、生产商三者身份的有效 互换，成就京贝尔联营商，让全球客户 自觉自发的参与到京贝尔智能合约中',
    tt24: '两会解读',
    ct24: '2019年两会提出金融要为实体经济服 务，满足经济发展和人民群众需要， 经济是肌体，金融是血脉，共生共荣',
    tt31: '京贝尔简介',
    ct31: '京贝尔（京贝尔（广州）科技有限公司），成立于2017年12月， 总部坐落于广州南沙自贸区。京贝尔主要由四大板块组成: 京贝尔通证商城、京贝尔钢镚（GB）云店、京贝尔共鸣（GM）社区、京贝尔美美妙数据坞，目前四大板块已经相继落地。 京贝尔独创了平台型参与市场众包的联营商模式——GMB模式，该模式提供了良性循环而有未来的经济模型——“订单式消费，定 制化生产”。京贝尔秉持“成就于分享”的经营理念，与所有合作伙伴一起成长。打造公平贸易，推动社会诚信，伸张消费主权，提升消费价值。给全体联合创业者提供一个“共享、共赢、共富、共 荣、共有”的联合创富平台。以资源深度交互为因，利益深度交互为果，利用粉丝经济学和市场倍增学的原理，通过财富链和诚信链的价值融合，将互联网、区块链、物联网、大数据等技术开发成数字化营销工具,服务于大众，包括通用积分、超级聚合支付、 数据管理等功能；线上、线下完美融合，全自动无感营销,为商户新零售赋能，循环服务，促进消费。 京贝尔已经申请多项软件著作权、专利以及商标，资质齐全，安全无忧。京贝尔自行研发的GMB联合信用计划和VB微积分计划相得益彰，动态支持。在不同产品之间、人与人之间、现在和未 来之间，信用价值与VB利润交互转换，相互印证。',
    tt32: '公司资质',
    ct32: '公司已于2018-2019年进行了全国分布式试点，2020年选定 青岛作为全国市场运营总部，联合有志于实体经济转型的企业 与个人在全国近百个城市进行战略布局，建设京贝尔云店的服 务网点，积极促进实体经济互联网+转型升级。 京贝尔将建立健全市场服务功能，发挥好第三方平台 持有 公信力，横向集聚联营商资源，促进全球经济发展。GTB 模式是贸易全球化、贸易自由化和商业网络化（General- Mobile-Business）交互促动的必然结果。',
    tt41: '领导团队',
    img21: '/images/ecology/zh21.jpg',
    leader: [{
        id: 1,
        img: '/images/ecology/l1.jpg',
        name: "James Bo",
        job: "联合创始人 首席战略官",
        intro: "美国华盛金融科技总裁 清华大学和美国辛辛那提大学 双硕士 清华数字研究院《大数据智能 系列丛书》编委 中国科协海智专家 大学教授 美国国际应用科技研究院院长",
      },
      {
        id: 2,
        img: '/images/ecology/l2.jpg',
        name: "罗洪堂",
        job: "总裁 CEO",
        intro: "知名上市公司总裁 多家知名企业名誉顾问 国家级讲师 国际营销培训师",
      },
      {
        id: 3,
        img: '/images/ecology/l3.jpg',
        name: "王悦蘅",
        job: "生态运营官",
        intro: "著名投资家 企业上市指导师 北大政府管理学院特约资本导师 环球青年创业联盟中华区主曾任 人民日报财富杂志出品人",
      },
      {
        id: 4,
        img: '/images/ecology/l4.jpg',
        name: "Jin Kecheng",
        job: "营销总监",
        intro: "中国十大培训名师 前沿讲座主讲嘉宾 深圳电视台创客风云汇创客导师 中国现场演说成交第一人 中国创客第一人 中国存在智慧系列课程创始人",
      },
      // {
      //   id: 5,
      //   img: '/images/ecology/l5.jpg',
      //   name: "来庆友",
      //   job: "技术总监",
      //   intro: "高级软 件 工 程 师 获美国P M P 项目 管 理 师认 证 （ 5A ） 六西格 玛 管理 黑 带 精 通S C R U M 敏 捷 项 目 管理",
      // },
    ],
    tt51: '主营业务',
    items5: [{
        id: 1,
        img: '/images/ecology/zh51.jpg',
        title: "京贝尔通证商城",
        text: "主要针对：土特产、老字号、新 奇特、大健康、GB特供等产品进 行定点定制营销",
      },
      {
        id: 2,
        img: '/images/ecology/zh52.jpg',
        title: "京贝尔云店",
        text: "线下千城万万店计划，聚合支付， 一码通天下",
      },
      {
        id: 3,
        img: '/images/ecology/zh53.jpg',
        title: "区块链技术开发及应用（数据坞）",
        text: "数据坞为广大客户提供数字资产 存储、交互、信贷等功能 为相关企业进行链改、产品溯源、 区块链技术应用等",
      },
      {
        id: 4,
        img: '/images/ecology/zh54.jpg',
        title: "GoMe社区",
        text: "软件开发、社交、进行视频、直 播、游戏等文娱深度交互 主要针对：土特产、老字号、新 奇特、大健康、GB特供等产品进 行定点定制营销 线下千城万万店计划，聚合支付， 一码通天下",
      },
    ],
    tt61: '专利证书',
    tt71: '时代红利',
    times7: [{
        id: 1,
        date: "2011年前",
        text: "实体产业丨工厂、商超、连锁百货",
      },
      {
        id: 2,
        date: "2011年",
        text: "第一代电子商务丨阿里巴巴、淘宝网、京东商城",
      },
      {
        id: 3,
        date: "2014年",
        text: "第二代电子商务丨大众点评、美团、拼多多、互联网社交",
      },
      {
        id: 4,
        date: "2019年",
        text: "第三代电子商务丨互联网＋金融＋区块链技术，深度融合",
      },
    ],
    tt72: '项目优势',
    cards7: [{
        id: 1,
        img: "/images/ecology/30.jpg",
        title: "大趋势",
        content: "国家政策支持，十大知名集团联合发力",
      },
      {
        id: 2,
        img: "/images/ecology/31.jpg",
        title: "低门槛",
        content: "人人可参与，个个可分红",
      },
      {
        id: 3,
        img: "/images/ecology/32.jpg",
        title: "去中心化",
        content: "数据公开透明，智能合约保证交易公平性",
      },
      {
        id: 4,
        img: "/images/ecology/33.jpg",
        title: "不可篡改",
        content: "分布式数据库账本技术和哈希加密功能,提供更高级别的保障",
      },
      {
        id: 5,
        img: "/images/ecology/34.jpg",
        title: "自由流通",
        content: "不同生态领域自由流通兑换，打破传统积分鸿沟",
      },
      {
        id: 6,
        img: "/images/ecology/35.jpg",
        title: "超级聚合支付",
        content: "一次扫码完成收款、锁粉、分佣结算、优惠券派发多重业务全自动无感营销",
      },
    ],
    tt81: '战略合作',
    tt82: '战略目标',
    ct82: [{
        id: 1,
        title: "新趋势",
        text: "具有强大生命力，市场前景广阔， 代表未来发展的趋势",
      },
      {
        id: 2,
        title: "新价值",
        text: "具备的高回报、高成长性的特点",
      },
      {
        id: 3,
        title: "新起点",
        text: "历史性转折的起点",
      },
    ],
    pt: [
      '全国多家知名集团与京贝尔打造通证商业行业标杆',
      '晶叶（青岛）生物科技有限公司',
      '海南鲁民医药科技有限公司',
      '奇妙科技有限公司',
      '海南三风友制药有限公司',
      '陕西汉道昌茯茶有限公司',
      '泰安合生世纪生物科技有限公司',
      '北京太爱肽生物工程技术有限公司',
      '遵义陆圣康源科技开发有限责任公司',
      '青岛净美生物科技有限公司',
      '大连锦田特种粮有限公司',
      '山东秒悦生物技术有限公司',
      '广西生命之菌生物科技有限公司'
    ]
  },
  ou: {
    img1: '/images/ahead/zh01.jpg',
    tt1: '展望京贝尔',
    times: [{
        id: 1,
        date: "2020.10",
        text: "开启45天强力吸粉计划，汇聚5000位GTB忠实粉丝",
      },
      {
        id: 2,
        date: "2020.12",
        text: "成立核心市场营销架构，完成省、市各代理节点布局",
      },
      {
        id: 3,
        date: "2021.02",
        text: "落地应用全面执行，服务于千万家实体企业，打造集群产业生态大平台，做好产融结合",
      },
      {
        id: 4,
        date: "2021.05",
        text: "与多家投资机构及央企达成战略合作，为平台发展引入源源不断活力",
      },
      {
        id: 5,
        date: "2021.09",
        text: "完善更新技术机制，为平台提供持久稳定的技术保障",
      },
      {
        id: 6,
        date: "2021.12",
        text: "甄选汇聚优质店铺，推动5000家实体店铺加入京贝尔云店",
      },
      {
        id: 7,
        date: "2022",
        text: "引入国内国际优质资本，打造GTB公链，让每个企业都能实现品牌价值和经济价值，共享平台资源，让所有人收益",
      },
      {
        id: 8,
        date: "2023",
        text: "打造自己的链改交易所，为长期持有GTB的信仰者作保障，成为全球最值得信赖的链改服务公链",
      },
      {
        id: 9,
        date: "2024",
        text: "正式启动上市流程，成为全球最值得信赖的国际化平台",
      },
    ],
  },
  gtb: {
    img1: '/images/gtb/zh01.jpg',
    cd1: 'GTB“全球通宝”通用积分链，简称〖GTB通宝链〗，她是各种商业消费积分进行通证资产化的开放闭环通道。',
    cd2: 'GTB设计了积分通道的底层协议和基础框架，实现了多方积分价值互换的通信协议。积分通证资产和聚合商业互相融合，通过区块链便捷地实现流通价值确认、交换、转移、交易。',
    cd3: 'GTB在投资与消费通道中执行内置智能合约，实现多维商业世界的全渠道商业聚合。',
    cd4: 'GTB链采用多维组件架构，包括：数据组件、网络组件、共识组件、合约组件、应用组件等。',
    cd5: 'GTB公司致力于打造全球合作商家积分区块化，实现商家、消费者和投资者兑换价值最大化的数字资产链。在数字资产概念中，通常将积分称之为“Token”，积分链更多的是体现在区块链的一个价值体系中，来搭建一个完整的闭环生态圈，从用户，到应用，到网络，到商业价值，最后再回归用户，这才能成为一个完整的闭环生态圈',
    tt1: '关于GTB相关答疑',
    q1: '问：区块链积分生态是什么？',
    a1: '答：基于区块链技术的积分(数字资产)发行、管理和流通网络，任何企业和个人都可以便捷加入，成为资产方和渠道方，联合生态内外企业、商户、渠道、发行方等，进行积分(数字资产)的发行、汇兑和管理，实现不同数字资产之间互通互换，资产流通。',
    q2: '问：传统积分模式存在着哪些痛点？',
    a2: '答：积分兑换的限制多，门槛高；积分过于分散，无法共享累加使用；积分发行不透明，天然缺失公信力；中心化架构下，运营平台异常复杂；积分资料容易被黑客攻击，安全性低；',
    q3: '问：区块链积分优势是什么？',
    a3: `答：去中心化：确保数据的公开透明,并通过智能合约用代码自动实现交易逻辑,保证了交易的公平,使去中心化的组织运营成为可能。 不可篡改：区块链分布式数据库账本技术和哈希加密的防篡改功能,为积分信息、用户信息的安全提供了更加高级别的保障。 抗攻击性强：数据库高稳定性,区块链通过共享账本结构,确保用户数字资产安全,避免了积分数据被黑客盗取的风险。即使部分节点受到攻击,也不影响数据库的完整性。 私钥更安全：利用私钥签名交易和共识算法构建出强安全性的底层系统;每个区块链上的用户都将拥有自己的私钥,每笔交易都是通过私钥签名的,保证积分流通过程中的安全性。`
  },
}